import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WlcmButton } from '@wlcm/angular/button';
import { WlcmDateRangePicker } from '@wlcm/angular/datepicker';

@Component({
  selector: 'fb-date-range-picker-bp',
  imports: [WlcmButton],
  templateUrl: './date-range-picker-bp.component.html',
  styleUrl: './date-range-picker-bp.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerBpComponent {
  protected readonly picker = inject(WlcmDateRangePicker);
}
